import React, { useState, useEffect } from 'react';
import { ResetPassword } from 'shared/src/components';
import { useLocation } from 'wouter';
import { startPasswordReset, performPasswordReset } from '../fetchers';
import { SESSION_STORAGE_KEYS } from 'shared/src/constants';

export default function ResetPasswordScreen() {
  const [, navigate] = useLocation();
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState<boolean>(false);
  const [isPasswordReset, setIsPasswordReset] = useState<boolean>(false);

  const userId = window.sessionStorage.getItem(SESSION_STORAGE_KEYS.FORGOT_PASSWORD_USER_ID);

  useEffect(() => {
    if (!userId) navigate('~/login/forgot');
  }, []);

  const handleSuccessfulReset = () => {
    setIsPasswordReset(true);
    window.sessionStorage.removeItem(SESSION_STORAGE_KEYS.FORGOT_PASSWORD_USER_ID);
    setTimeout(() => {
      navigate('~/login');
    }, 5000);
  };

  async function passwordReset(resetCode: string, newPassword: string, userId: string): Promise<boolean> {
    setErrorMessage('');
    setLoading(true);

    try {
      const success = await performPasswordReset(resetCode, newPassword, userId);

      if (!success) {
        setErrorMessage('Password reset failed. Make sure you have the correct reset code.');
        return false;
      }

      return true;
    } catch (e) {
      setErrorMessage('Something went wrong. Make sure you have the correct reset code.');
      return false;
    } finally {
      setLoading(false);
    }
  }

  return (
    <ResetPassword
      startPasswordReset={startPasswordReset}
      performPasswordReset={passwordReset}
      onSuccessfulReset={handleSuccessfulReset}
      errorMessage={errorMessage}
      isPasswordReset={isPasswordReset}
      loading={loading}
    />
  );
}
